import React from "react";
import Playlist from "../../components/playlist/Playlist";

const PodcastsContainer = () => {
  return (
    <div className="w-full flex justify-center md:min-h-[calc(100vh_-_180px)]">
      {/* <Playlist /> */}
    </div>
  );
};

export default PodcastsContainer;
